import DashboardActionTypes from 'redux/dashboard/types';

const INITIAL_STATE = {
  error: null,
  isFetchingFinancialReports: false,
  isFetchingApplicationReports: false,
  candidatesByCourse: [],
  candidateSummary: { actual: 0, expected: 0 },
  applicationStatistics: {},
  isExpotingData: false,

  revenueByAmount: {},
  revenueByCourse: {},
  condtionalOfferSummary: {},
  revenueSummary: {},
  financialReportMetadata: null, // Store metadata for financial report
};

function DashboardReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case DashboardActionTypes.FETCH_DASHBOARD_STATISTICS:
      return {
        ...state,
        isFetchingApplicationReports: true,
      };
    case DashboardActionTypes.FETCH_FINANCIAL_REPORT:
      return {
        ...state,
        isFetchingFinancialReports: true,
      };
    case DashboardActionTypes.FETCH_FINANCIAL_REPORT_SUCCESS:
      // Always use the payload data - if API returns empty objects, that's what we should display
      // The backend should only return empty objects when there's truly no data
      return {
        ...state,
        isFetchingFinancialReports: false,
        revenueByAmount: payload.revenueByAmount ?? {},
        revenueByCourse: payload.revenueByCourse ?? {},
        condtionalOfferSummary: payload.conditionalOfferSummary ?? {},
        revenueSummary: payload.revenueSummary ?? {},
        financialReportMetadata: payload.metadata ?? null,
      };
    case DashboardActionTypes.FETCH_APPLICATION_REPORT_SUCCESS:
      return {
        ...state,
        isFetchingApplicationReports: false,
        candidatesByCourse: payload.candidatesByCourse,
        candidateSummary: payload.candidateSummary,
        applicationStatistics: payload.applicationStatistics,
      };
    case DashboardActionTypes.FETCH_STATISTICS_FAILURE:
      return {
        ...state,
        isFetchingFinancialReports: false,
        isFetchingApplicationReports: false,
        error: payload,
      };
    case DashboardActionTypes.EXPORT_DASHBOARD_START:
      return {
        ...state,
        isExpotingData: true,
      };
    case DashboardActionTypes.EXPORT_DASHBOARD_SUCCESS:
      return {
        ...state,
        isExpotingData: false,
      };
    case DashboardActionTypes.EXPORT_DASHBOARD_FAILURE:
      return {
        ...state,
        isExpotingData: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default DashboardReducer;
